import { Box, Container } from "@chakra-ui/react";

import { Header } from "components";

const AboutPage = () => {
  return (
    <>
      <Header />

      <Container pb="2rem" maxW="container.lg" color="grayTxt">
        <Box
          as="h1"
          textAlign="center"
          color="grayTitle"
          fontSize="xl"
          my="1rem"
        >
          About
        </Box>
        <Box
          fontWeight="bold"
          as="h3"
          color="grayTitle"
          fontSize="l"
          mb="0.5rem"
        >
          About Collocations
        </Box>
        <Box as="p">
          Collocations are groups of words that often occur together, like:
        </Box>
        <Box as="ul" pl="1rem" mb="0.5rem">
          <Box as="li">fast food (not “quick food”)</Box>
          <Box as="li">strong tea (not “thick tea”)</Box>
          <Box as="li">needle in a haystack (not “needle in the ocean”)</Box>
        </Box>
        <Box as="p" mb="1rem">
          Knowing collocations can help you speak and write more naturally, and
          can make it easier to answer Vocabulary and Cloze test questions.
        </Box>

        <img
          className="thumb-image loaded"
          data-src="https://images.squarespace-cdn.com/content/v1/563c49eae4b0c01d8b278c90/1498208387185-44UPYKU433G0I71471D8/image-asset.jpeg"
          data-image="https://images.squarespace-cdn.com/content/v1/563c49eae4b0c01d8b278c90/1498208387185-44UPYKU433G0I71471D8/image-asset.jpeg"
          data-image-dimensions="2500x1667"
          data-image-focal-point="0.5,0.5"
          alt=""
          data-load="false"
          data-image-id="594cd827b8a79b2354581e3e"
          data-type="image"
          data-image-resolution="2500w"
          src="https://images.squarespace-cdn.com/content/v1/563c49eae4b0c01d8b278c90/1498208387185-44UPYKU433G0I71471D8/image-asset.jpeg?format=2500w"
        />

        <Box
          fontWeight="bold"
          as="h3"
          color="grayTitle"
          fontSize="l"
          mt="2rem"
          mb="0.5rem"
        >
          About Us
        </Box>
        <Box as="p" mt="0.5rem" mb="2rem">
          Zhicheng Private School, Singapore, was established in 2002. We
          specialise in teaching English to international students, and prepare
          them for the GCE O-Level examinations and Cambridge International
          A-Level examinations, as well as the Admissions Exercise for
          International Students (AEIS) tests.
        </Box>
        <Box display="flex" alignItems="flex-end">
          <Box as="img" width="80px" src="/images/qr.png" alt="qr" />
          <Box ml="1rem" as="a" href="https://www.zhicheng.edu.sg/">
            https://www.zhicheng.edu.sg/
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default AboutPage;
